"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAddWalkinInspectionDto = instanceOfAddWalkinInspectionDto;
exports.AddWalkinInspectionDtoFromJSON = AddWalkinInspectionDtoFromJSON;
exports.AddWalkinInspectionDtoFromJSONTyped = AddWalkinInspectionDtoFromJSONTyped;
exports.AddWalkinInspectionDtoToJSON = AddWalkinInspectionDtoToJSON;
exports.AddWalkinInspectionDtoToJSONTyped = AddWalkinInspectionDtoToJSONTyped;
/**
 * Check if a given object implements the AddWalkinInspectionDto interface.
 */
function instanceOfAddWalkinInspectionDto(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('listingId' in value) || value['listingId'] === undefined)
        return false;
    if (!('inspectionStartTime' in value) || value['inspectionStartTime'] === undefined)
        return false;
    if (!('inspectionEndTime' in value) || value['inspectionEndTime'] === undefined)
        return false;
    return true;
}
function AddWalkinInspectionDtoFromJSON(json) {
    return AddWalkinInspectionDtoFromJSONTyped(json, false);
}
function AddWalkinInspectionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'email': json['email'] == null ? undefined : json['email'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'listingId': json['listingId'],
        'inspectionStartTime': json['inspectionStartTime'],
        'inspectionEndTime': json['inspectionEndTime'],
    };
}
function AddWalkinInspectionDtoToJSON(json) {
    return AddWalkinInspectionDtoToJSONTyped(json, false);
}
function AddWalkinInspectionDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'email': value['email'],
        'countryCode': value['countryCode'],
        'phoneNumber': value['phoneNumber'],
        'listingId': value['listingId'],
        'inspectionStartTime': value['inspectionStartTime'],
        'inspectionEndTime': value['inspectionEndTime'],
    };
}
